import { Builder } from '@builder.io/react';
import { BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES } from '../BuilderComponentsName';
import { BuilderTestComponent } from '../components/interactive-sections/BuilderTestComponent';
import { MilanTextColor } from '../types';


Builder.registerComponent(BuilderTestComponent, {
    name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.BuilderTestComponent,
    hideFromInsertMenu: true,
    friendlyName: 'Builder Test Component',
    inputs: [
        {
            name: 'headline',
            type: 'string',
            required: true,
            defaultValue: 'Underarm Laser Hair Removal',
            friendlyName: 'Headline',
            helperText: 'Main headline text for the hero section',
        },
        {
            name: 'headlineColor',
            type: 'string',
            defaultValue: 'Turquoise',
            enum: [...Object.values(MilanTextColor)],
            friendlyName: 'Headline Color',
            helperText: 'Color for the headline text',
        },
        {
            name: "headlineTypographyVariant",
            type: 'string',
            defaultValue: 'h1Hero',
            enum: [
                'h1Hero',
                'h1SmallTitle',
                'h2SubheadLg',
                'h2SubheadSm',
                'h3SubpointLg',
                'h3SubpointSm',
                'h4Footer',
                'h5Subheader',
                'h6FormSubheader',
            ]
               
        },
        {
            name: 'subHeadline',
            type: 'string',
            required: true,
            defaultValue: 'Smooth Underarms, Confident You',
            friendlyName: 'Sub Headline',
            helperText: 'Sub headline text for the hero section',
        },
        {
            name: 'description',
            type: 'string',
            required: true,
            defaultValue:
                'Raise your arms and wear sleeveless tops with confidence and smooth underarms! With underarm laser hair removal treatments, you can say goodbye to coarse hair, itchy pits, and prickly unwanted hair. Throw away the razor, toss out the at-home laser hair removal devices, and get smooth pits for good!',
            friendlyName: 'Description',
            helperText: 'Supporting text content below the headline',
        },
        {
            name: 'descriptionColor',
            type: 'string',
            defaultValue: 'Navy',
            enum: [...Object.values(MilanTextColor)],
            friendlyName: 'Description Color',
            helperText: 'Color for the main text content',
        },
        {
            name: 'imageURL',
            type: 'file',
            defaultValue:
                'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F05469c89ae97422fbd33b56b1a604050',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'gif', 'svg'],
            friendlyName: 'Image',
            helperText: 'Upload an image or provide an image URL for the hero section',
        },
        {
            name: 'imageAltText',
            type: 'string',
            friendlyName: 'Image Alt Text',
            required: true,
            helperText: 'Alt text for the image',
        },
       
    ],
});
